import useTranslation from 'next-translate/useTranslation';
import React from 'react';

const ProductCardLightingLine = props => {
  const { t } = useTranslation('common');
  const { data } = props;
  if (!data?.show_progress) {
    return null;
  }
  return (
    <div className="mt-1 px-2" data-role="claimed">
      <div className="h-2 w-full rounded mb-[6px] bg-surface-200-bg">
        <div className="h-2 rounded bg-pricing-bg" style={{ width: `${data?.progress || 0}%` }} />
      </div>
      <div className="text-pricing-txt enki-body-2xs-medium">{t('claimed', { progress: data?.progress || 0 })}</div>
    </div>
  );
};

export default React.memo(ProductCardLightingLine);
